import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

import InfoPopover from "../../components/popups/InfoPopover";
import StatusPopup from "../../components/popups/StatusPopup";
import ChequeNumberPopup from "../../components/popups/ChequeNumberPopup";

import edit_icon from "../../assets/images/edit_icon.svg";

const EmployePayrollTable = ({
  employees = [],
  headerId,
  onUpdateWorkDetails,
  onGenerate,
  loading = false,
  loadingId,
  showErrorPopup,
  errorMessage,
  closeErrorPopup,
  page = 1,
  pageSize = 10,
  totalRecords = 0,
  onPageChange,
  canGenerate = false,
}) => {
  const [employeeData, setEmployeeData] = useState([]);
  const [showChequePopup, setShowChequePopup] = useState(false);
  const [selectedEmployeeIndex, setSelectedEmployeeIndex] = useState(null);
  const [chequeNumber, setChequeNumber] = useState("");

  useEffect(() => {
    setEmployeeData(employees.map(emp => ({
      ...emp,
      accountType: emp.accountType || "DD",
      chequeNumber: emp.chequeNumber || ""
    })));
  }, [employees]);

  const handleInputChange = (index, field, value) => {
    const updated = [...employeeData];
    updated[index] = { ...updated[index], [field]: value };
    setEmployeeData(updated);
  };

  const handleAccountTypeChange = (index, accountType) => {
    if (accountType === "Cheque") {
      setSelectedEmployeeIndex(index);
      setChequeNumber(employeeData[index]?.chequeNumber || "");
      setShowChequePopup(true);
    } else {
      const updated = [...employeeData];
      updated[index] = { ...updated[index], accountType, chequeNumber: "" };
      setEmployeeData(updated);
    }
  };

  const handleChequeConfirm = () => {
    if (selectedEmployeeIndex !== null) {
      const updated = [...employeeData];
      updated[selectedEmployeeIndex] = {
        ...updated[selectedEmployeeIndex],
        accountType: "Cheque",
        chequeNumber
      };
      setEmployeeData(updated);
      setShowChequePopup(false);
      setSelectedEmployeeIndex(null);
      setChequeNumber("");
    }
  };

  const handleUpdate = (index) => {
    if (!headerId || !onUpdateWorkDetails) return;

    const emp = employees[index];
    const updatedEmp = employeeData[index];

    const dto = {
      PayrollEmployeeId: emp.payrollEmployeeId,
      TotalHours: parseFloat(updatedEmp?.totalHours) || 0,
      Rate: parseFloat(updatedEmp?.rate) || 0,
      AccountType: updatedEmp?.accountType || "DD",
      ChequeNumber: updatedEmp?.chequeNumber || "",
    };

    onUpdateWorkDetails(headerId, [dto]);
  };

  const totalPages = Math.ceil(totalRecords / pageSize);

  return (
    <>
      <div className="custom_table employe_payroll_table table-responsive">
        <div className="table-wrapper">
          <table className="table mb-0">
            <thead>
              <tr>
                <th width="180">Employee Name</th>
                <th width="200">Address</th>
                <th width="80">Fixed Salary</th>
                <th width="80">Incentive</th>
                <th width="110">Total Hours</th>
                <th width="90">Regular</th>
                <th width="90">Over Time</th>
                <th width="90">Rate</th>
                <th>Gross</th>
                <th width="150">After Pre Tax Deduction</th>
                <th width="140">Total Tax</th>
                <th>Net Pay</th>
                <th width="160">Net Pay After Additional WH</th>
                <th width="120">Account</th>
                <th width="80">Action</th>
                <th width="120">Pay Check Printing</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={16} className="text-center">
                    <div className="d-flex justify-content-center align-items-center py-4">
                      <div className="spinner-border text-primary me-2" />
                      Loading payroll
                    </div>
                  </td>
                </tr>
              ) : employees.length > 0 ? (
                employees.map((emp, index) => (
                  <tr key={emp.payrollEmployeeId}>
                    <td className="text-start">
                      <div className="d-flex align-items-center">
                        <div className="user_img me-2">
                          <img
                            src={
                              emp.image
                            }
                            alt="user"
                          />
                        </div>
                        {emp.name}
                      </div>
                    </td>

                    <td className="text-start">
                      <p className="mb-0">{emp.address || "-"}</p>
                    </td>

                    <td>{emp.fixedSalary || "-"}</td>
                    <td>{emp.incentive || "-"}</td>

                    <td className="valeu_td">
                      <input
                        type="text"
                        className="table_form"
                        placeholder="00"
                        value={employeeData[index]?.totalHours || ""}
                        onChange={(e) => handleInputChange(index, 'totalHours', e.target.value)}
                      />
                    </td>

                    <td>{emp.regularHours || "-"}</td>
                    <td>{emp.overtime || "0"}</td>

                    <td className="valeu_td">
                      <input
                        type="text"
                        className="table_form"
                        value={employeeData[index]?.rate || ""}
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "rate",
                            e.target.value
                          )
                        }
                      />
                    </td>

                    <td>{emp.gross || "-"}</td>

                    <td className="bg_more_light_blue">
                      {emp.afterPreTax || "-"}
                      <InfoPopover
                        title="Pre-Tax Deductions"
                        items={emp.deductions}
                      />
                    </td>

                    <td className="">
                      {emp.totalTax || "-"}
                      <InfoPopover
                        title="Taxes"
                        items={emp.taxes}
                      />
                    </td>

                    <td className="bg_more_light_blue">
                      {emp.netPay || "-"}
                    </td>

                    <td className="bg_more_light_blue">
                      {emp.netPayAfterWH || "-"}
                    </td>

                    <td>
                      <DropdownButton
                        title={employeeData[index]?.accountType || "DD"}
                        className="custom_dropdown w-100"
                      >
                        <Dropdown.Item onClick={() => handleAccountTypeChange(index, "DD")}>DD</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleAccountTypeChange(index, "Cheque")}>Cheque</Dropdown.Item>
                      </DropdownButton>
                    </td>

                    <td>
                      <button
                        type="button"
                        className="icon_btn"
                        disabled={canGenerate === true}
                        onClick={() => handleUpdate(index)}
                      >
                        <img src={edit_icon} alt="edit" />
                      </button>
                    </td>

                    <td>
                      <button
                        className="btn_genrate"
                        disabled={canGenerate === false}
                        onClick={() =>
                          onGenerate(emp.payrollEmployeeId)
                        }
                      >
                        {loadingId === emp.payrollEmployeeId
                          ? "Generating"
                          : "Generate"}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={16} className="text-center">
                    No Payroll Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* PAGINATION FOOTER */}
        {totalRecords > 0 && (
          <div className="table_footer">
            <div className="footer_left">
              Showing {(page - 1) * pageSize + 1}–
              {Math.min(page * pageSize, totalRecords)} of{" "}
              {totalRecords} entries
            </div>

            <div className="footer_right">
              <button
                className="page_btn"
                disabled={page === 1}
                onClick={() => onPageChange(page - 1)}
              >
                ‹ Previous
              </button>

              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  className={`page_btn ${page === i + 1 ? "active" : ""
                    }`}
                  onClick={() => onPageChange(i + 1)}
                >
                  {String(i + 1).padStart(2, "0")}
                </button>
              ))}

              <button
                className="page_btn"
                disabled={page === totalPages}
                onClick={() => onPageChange(page + 1)}
              >
                Next ›
              </button>
            </div>
          </div>
        )}
      </div>

      <StatusPopup
        show={showErrorPopup}
        type="error"
        message={errorMessage}
        handleClose={closeErrorPopup}
      />

      <ChequeNumberPopup
        show={showChequePopup}
        onHide={() => setShowChequePopup(false)}
        onConfirm={handleChequeConfirm}
        chequeNumber={chequeNumber}
        setChequeNumber={setChequeNumber}
      />
    </>
  );
};

export default EmployePayrollTable;
